import { render, staticRenderFns } from "./LoveMapProduct.vue?vue&type=template&id=36b7bd1b&scoped=true&"
import script from "./LoveMapProduct.vue?vue&type=script&lang=js&"
export * from "./LoveMapProduct.vue?vue&type=script&lang=js&"
import style0 from "./LoveMapProduct.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./LoveMapProduct.vue?vue&type=style&index=1&id=36b7bd1b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b7bd1b",
  null
  
)

export default component.exports